import React from "react";
import {Button} from "@material-ui/core";


const ManagementReportComponent = () => {





  return(
    <div className="px-3">
      <Button  className="default-font outline-none" href="#/reports" color="secondary">Informe gerencial</Button>
    </div>
  );
};

export default ManagementReportComponent;
